import React, { useContext, useState } from 'react'
import Modal from 'react-modal'
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Flex } from 'rebass'

import Button from './Button'
import { useMediaQuery } from 'react-responsive'
import { GameDifficultyContext } from '../utils/GameModeContext'
import { isNovice } from '../utils/utility'

const overlayModalClass = css`
  background: transparent;
`

const customStyles = {
  content: {
    backgroundColor: 'white',
    borderRadius: '4px',
    margin: 'auto',
    width: '25%',
    height: '50%'
  }
}

const customStylesMobile = {
  content: {
    backgroundColor: 'white',
    borderRadius: '4px',
    width: '90vw',
    height: '90vh',
    left: 0,
    top: 0
  }
}

const Title = styled('span')`
  text-transform: uppercase;
  font-size: 24px;
  font-weight: 700;
`

const ModalHeader = styled(Flex)`
  width: 100%;
  color: ${({ theme }) => theme.colors.components.modal.title};
  align-items: center;
  justify-content: space-between;
`

const CloseIcon = styled('img')`
  width: 20px;
  height: 20px;
  cursor: pointer;
`

const RulesModal = () => {
  const { difficulty } = useContext(GameDifficultyContext)
  const isSmallScreen = useMediaQuery({
    query: '(max-width: 1366px)'
  })
  const [showRulesModal, setShowRulesModal] = useState(false)

  const handleModalShow = () => {
    setShowRulesModal(!showRulesModal)
  }

  return (
    <>
      <Button onClick={handleModalShow}>Rules</Button>
      <Modal
        style={isSmallScreen ? customStylesMobile : customStyles}
        overlayClassName={overlayModalClass.name}
        isOpen={showRulesModal}
        ariaHideApp={false}>
        <Flex flexDirection="column" height="100%" justifyContent="space-between">
          <ModalHeader>
            <Title>Rules</Title>
            <CloseIcon onClick={handleModalShow} src="./images/icon-close.svg" />
          </ModalHeader>
          <Flex justifyContent="center" alignItems="center" height="100%">
            <img
              alt="rules"
              src={
                isNovice(difficulty) ? './images/image-rules.svg' : './images/image-rules-bonus.svg'
              }
            />
          </Flex>
        </Flex>
      </Modal>
    </>
  )
}

export default RulesModal
